import { object, string } from 'yup';
var ChallengeSchema = object().shape({
  challengeAnswer: string().required('Verification code is required!')
});
export { ChallengeSchema };